class ContactPage extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.topicSelect = this.querySelector('[data-contact-topic]');
    this.chips = Array.from(this.querySelectorAll('[data-contact-topic-chip]'));
    if (!this.topicSelect || !this.chips.length) return;

    this.chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        this.topicSelect.value = chip.dataset.contactTopicChip;
        this.topicSelect.dispatchEvent(new Event('change', { bubbles: true }));
        this.syncChips();
        const comment = this.querySelector('#ContactForm-body');
        if (comment) comment.focus();
      });
    });

    this.topicSelect.addEventListener('change', () => this.syncChips());
    this.syncChips();
  }

  syncChips() {
    const value = this.topicSelect.value;
    this.chips.forEach((chip) => {
      const active = chip.dataset.contactTopicChip === value;
      chip.classList.toggle('is-active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
}

if (!customElements.get('contact-page')) {
  customElements.define('contact-page', ContactPage);
}
